import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import SliderBtn from "../../componets/SliderBtn";
import sliderVideoJson from "../../data/sliderVideo.json";

export default function Section6() {
  const sliderData = sliderVideoJson;
  const videoRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video
              .play()
              .catch((error) =>
                console.error("Error playing the video:", error)
              );
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    videoRefs.current.forEach((video) => {
      if (video) {
        observer.observe(video);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    cssEase: "linear",
    nextArrow: (
      <SliderBtn
        direction="next"
        position={{ right: "5%", opacity: "0.4" }}
      />
    ),
    prevArrow: (
      <SliderBtn
        direction="prev"
        position={{ left: "5%", opacity: "0.4" }}
      />
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: false,
          dots: true,
          arrows: false,
          cssEase: "linear",
        },
      },
    ],
  };

  return (
    <div className="Section6 w-full text-white pt-10 pb-[45px]">
      <div className="w-full section6-container">
        <h3 className="text-2xl md:text-4xl font-bold mb-10 text-[#da2128] text-center">
          CLIENT TESTIMONIALS
        </h3>
        <Slider {...settings}>
          {sliderData.map((item, index) => (
            <div key={index}>
              <div className="w-full xl:w-[100%] h-[190px] md:h-auto mx-auto container-1280">
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  className="object-cover w-full h-full"
                  src={item.url}
                  controls={true}
                  muted={true}
                  preload="metadata"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
